var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77778 13.3985H12.4444V6.17425L7 1.81503L1.55556 6.17425V13.3985H6.22222V8.59409H7.77778V13.3985ZM14 14.1993C14 14.4116 13.9181 14.6153 13.7722 14.7655C13.6263 14.9156 13.4285 15 13.2222 15H0.777778C0.571498 15 0.373668 14.9156 0.227806 14.7655C0.0819444 14.6153 1.87219e-07 14.4116 1.87219e-07 14.1993V5.78349C-8.20428e-05 5.66147 0.0269245 5.54104 0.0789569 5.43141C0.130989 5.32177 0.206671 5.22583 0.300222 5.15091L6.52244 0.168711C6.65898 0.0593662 6.82702 0 7 0C7.17298 0 7.34102 0.0593662 7.47756 0.168711L13.6998 5.15091C13.7933 5.22583 13.869 5.32177 13.921 5.43141C13.9731 5.54104 14.0001 5.66147 14 5.78349V14.1993Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHome);
export default __webpack_public_path__ + "static/media/menu-home.f35408d68a5cf919a0ef6935d51ef62c.svg";
export { ForwardRef as ReactComponent };